import { render } from "./ManageUserContent.vue?vue&type=template&id=4789b1d7"
import script from "./ManageUserContent.vue?vue&type=script&lang=js"
export * from "./ManageUserContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__